import { render, staticRenderFns } from "./QServRedPacketComp.vue?vue&type=template&id=5f938f92&scoped=true&"
import script from "./QServRedPacketComp.vue?vue&type=script&lang=js&"
export * from "./QServRedPacketComp.vue?vue&type=script&lang=js&"
import style0 from "./QServRedPacketComp.vue?vue&type=style&index=0&id=5f938f92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f938f92",
  null
  
)

export default component.exports